import { render, staticRenderFns } from "./ItemModifiers.vue?vue&type=template&id=3da61473"
import script from "./ItemModifiers.vue?vue&type=script&lang=js"
export * from "./ItemModifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports